import { ServerStackIcon } from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Data Connector",
    href: "/hub/data-connector",
    icon: ServerStackIcon,
    current: false,
    internalName: "data_connector",
    permissions: ["data-connector"],
  },
];

const dataConnectorConfig = {
  sectionName: "data-connector",
  defaultRoute: "/hub/data-connector",
  navigation,
};

export default dataConnectorConfig;
